const delay = (ms) => new Promise((res) => setTimeout(res, ms));

const dialog = document.getElementById('newsletter-dialog');
const closeButton = document.getElementById('newsletter-dialog__close');
const form = document.getElementById('newsletter-dialog__form');

document.addEventListener('DOMContentLoaded', async () => {
  const submitted = localStorage.getItem('NEWSLETTER_SUBMITTED');
  const alreadySeen = localStorage.getItem('NEWSLETTER_MODAL_SEEN');

  if (!dialog || alreadySeen) return;

  if (!submitted) {
    await delay(10000);
  }

  dialog.showModal();
});

closeButton.addEventListener('click', () => {
  if (dialog) {
    dialog.close();
  }
});

dialog.addEventListener('close', () => {
  localStorage.setItem('NEWSLETTER_MODAL_SEEN', true);
});

// Backdrop click
dialog.addEventListener('mousedown', (event) => {
  if (event.target === event.currentTarget) {
    event.currentTarget.close();
    localStorage.setItem('NEWSLETTER_MODAL_SEEN', true);
  }
});

form.addEventListener('submit', (e) => {
  e.preventDefault();
  localStorage.setItem('NEWSLETTER_SUBMITTED', true);
  form.submit();
});
